import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { useCallback, useEffect, useRef } from '@redneckz/uni-jsx/lib/hooks';
import { useOutsideClick } from '@redneckz/uni-jsx/lib/hooks/useOutsideClick';
import { usePopupManager } from '../PopupManager/usePopupManager.js';
import { SelectPopup } from './SelectPopup.js';
export function useSelectPopup({ isOpen, options, value, query, onChange, onClose, iconVersion, }) {
    const popup = usePopupManager();
    const close = useCallback(() => {
        popup.close();
        onClose && onClose();
    }, [onClose]);
    const handleChange = useCallback((option) => {
        close();
        onChange && onChange(option);
    }, [close, onChange]);
    const inputRef = useRef(null);
    const popupRef = useOutsideClick(close);
    useEffect(() => {
        if (!isOpen || !inputRef.current) {
            return;
        }
        const inputElement = inputRef.current;
        const { top, left, width, height } = inputElement.getBoundingClientRect();
        popup.update(_jsx(SelectPopup, { popupRef: popupRef, options: options, value: value, query: query, onChange: handleChange, iconVersion: iconVersion }), {
            top: top + window.scrollY + height,
            left,
            width,
        });
    }, [isOpen, options, value, query, handleChange]);
    return inputRef;
}
//# sourceMappingURL=useSelectPopup.js.map